/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../common/day_of_week';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "BusinessHoursPeriod": {
                    "fields": {
                      "dayOfWeek": {
                        "type": ".squareup.connect.v2.common.DayOfWeek",
                        "id": 1,
                        "rule": "optional"
                      },
                      "startLocalTime": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "endLocalTime": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.resources?.nested?.BusinessHoursPeriod) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc
 * Represents a period of time during which a business location is open.
 * --
 *
 * SOURCE BusinessHoursPeriod @ squareup/connect/v2/resources/location.proto at 237:1
 */
export const BusinessHoursPeriod = $root.lookupType('squareup.connect.v2.resources.BusinessHoursPeriod');
fixType(BusinessHoursPeriod);
Builder.createAndAttachToType(BusinessHoursPeriod);